export default "__VITE_PUBLIC_ASSET__dbe23b3d__"